import { render, staticRenderFns } from "./KnFormStudent.vue?vue&type=template&id=f0cdf734"
import script from "./KnFormStudent?vue&type=script&lang=js&external"
export * from "./KnFormStudent?vue&type=script&lang=js&external"
import style0 from "./KnFormStudent.vue?vue&type=style&index=0&id=f0cdf734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports